import { render } from "./ai-search-component.vue?vue&type=template&id=0befef3c"
import script from "./ai-search-component.vue?vue&type=script&lang=js"
export * from "./ai-search-component.vue?vue&type=script&lang=js"

import "./ai-search-component.vue?vue&type=style&index=0&id=0befef3c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__